import { ErrorHandler, Injectable } from '@angular/core'
import { LoggerService } from './logger.service'
import { environment } from 'src/environments/environment'

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private logger: LoggerService) {}

  handleError(error: any): void {
    if (!!environment?.dataDogConfigLogs) this.logger.error('An unhandled error occurred', { error })

    console.log(error)
  }
}
